<geaui-button-v3 [disabled]="buttonDisabled" (click)="toggle($event)">
  <div class="flex gap-2 align-items-center">
    Publish Workspace {{ uncommittedCount > 0 ? '(' + uncommittedCount + ')' : '' }}
    <i class="pi pi-chevron-down"></i>
  </div>
</geaui-button-v3>
<p-popover #workspaceOptionsRef appendTo="body" styleClass="no-arrow-popover">
  <div class="popover-content">
    @for (menuOption of options; track menuOption) {
      <div class="popover-item" [class.disabled]="menuOption.disabled" (click)="onOptionClick(menuOption)">
        <i [class]="menuOption.icon"></i>
        <span>{{ menuOption.label }}</span>
      </div>
    }
  </div>
</p-popover>
